import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Panel } from 'react-bootstrap';
import compact from 'lodash/compact';
import uniq from 'lodash/uniq';
import withRoute from 'containers/withRoute';
import withClubs from 'containers/Clubs/withEntity';
import InfoControlPanel from 'components/InfoControlPanel';
import CloseButton from 'components/CloseButton';
import Flex from 'components/Flex';
import ShareLink from 'components/ShareLink';
import { injectIntl, intlShape } from 'react-intl';
import { EMBEDDED } from 'containers/App/constants';
import messages from './messages';
import getLocation from './getLocation';

function ClubInfo(props) {
  const { clubs, clubId, intl, goTo, locationId } = props;
  if (!clubs || !clubs.current || clubs.current.id !== clubId) {
    return null;
  }
  const club = clubs.current;
  const clubLocation = getLocation(club, locationId);
  const websiteString = club.website
    .replace(/^https?:\/\//, '')
    .replace(/\/$/, '');

  const hide = () => goTo('/home');

  const locations = club.locations.map(loc => ({
    ...loc,
    locString: `${loc.lat},${loc.lng}`,
    name: loc.accommodation || loc.city,
    title: compact([loc.accommodation, loc.address, loc.city]).join(', '),
  }));
  const locationString =
    clubLocation && `${clubLocation.lat},${clubLocation.lng}`;

  // const startingPoint = intl.formatMessage(messages.startingPoint);
  return (
    <InfoControlPanel>
      {!EMBEDDED && (
        <Panel.Heading>
          <CloseButton onClose={hide} />
          <Flex align="baseline">
            <h2>{club.name}</h2>&nbsp;&nbsp;
            <a href={club.website} className="nowrap">
              <FontAwesomeIcon icon="globe-americas" />&nbsp;
              {websiteString}
            </a>
          </Flex>
          <div className="flex-description">
            <div>{uniq(locations.map(loc => loc.city)).join(', ')}</div>
            <ShareLink bsSize="small" className="px-0" />
          </div>
        </Panel.Heading>
      )}
      {clubLocation && (
        <Panel.Body>
          <Flex spaced center>
            {compact([clubLocation.accommodation, clubLocation.city]).join(
              ', ',
            )}
            <a
              className="btn btn-link btn-sm"
              href={`https://maps.google.com?daddr=${locationString}`}
              title={intl.formatMessage(messages.directions)}
              target={EMBEDDED ? '_blank' : '_self'}
            >
              <FontAwesomeIcon icon="directions" size="lg" />
            </a>
          </Flex>
        </Panel.Body>
      )}
    </InfoControlPanel>
  );
}

ClubInfo.propTypes = {
  clubId: PropTypes.number.isRequired,
  locationId: PropTypes.number.isRequired,
  clubs: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default compose(
  withRoute,
  withClubs,
  injectIntl,
)(ClubInfo);
